module.exports = __webpack_public_path__ + "media/newstyle/images/icon-burger-white-843845ef6f88dcf67b9b6da77ee22292.svg";